import { createCommand } from '../createCommand/createCommand';
/**
 * Creates a list of command definitions.
 *
 * @param commands The commands to create.
 * @remark This function should not be used at runtime as what it produces is
 * required to be static.
 */
export function createCommands(commands) {
    return commands.map((command) => createCommand(command));
}
